import { useEffect, useCallback } from 'react';
import { Coin } from './types';

export const useCoinMovement = (
  isActive: boolean,
  coins: Coin[],
  setCoins: (coins: Coin[]) => void
) => {
  const updatePosition = useCallback((coin: Coin, containerWidth: number, containerHeight: number) => {
    const nextX = coin.x + Math.cos(coin.direction) * coin.speed;
    const nextY = coin.y + Math.sin(coin.direction) * coin.speed;
    
    let newDirection = coin.direction;
    let newX = nextX;
    let newY = nextY;

    // Rebotar en los bordes
    if (nextX <= 0 || nextX >= containerWidth - coin.size) {
      newDirection = Math.PI - coin.direction;
      newX = nextX <= 0 ? 0 : containerWidth - coin.size;
    }
    if (nextY <= 0 || nextY >= containerHeight - coin.size) {
      newDirection = -coin.direction;
      newY = nextY <= 0 ? 0 : containerHeight - coin.size;
    }

    // Cambiar dirección aleatoriamente
    if (Math.random() < 0.02) {
      newDirection += (Math.random() - 0.5) * Math.PI / 2;
    }

    return {
      ...coin,
      x: newX,
      y: newY,
      direction: newDirection
    };
  }, []);

  useEffect(() => {
    if (!isActive) return;

    const updateCoins = () => {
      const container = document.querySelector('.game-container');
      if (!container) return;

      const containerWidth = container.clientWidth;
      const containerHeight = container.clientHeight;

      setCoins(prevCoins =>
        prevCoins.map(coin => {
          if (coin.collected) return coin;
          return updatePosition(coin, containerWidth, containerHeight);
        })
      );
    };

    const intervalId = setInterval(updateCoins, 1000 / 60); // 60 FPS
    window.addEventListener('resize', updateCoins);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('resize', updateCoins);
    };
  }, [isActive, setCoins, updatePosition]);
};